// extracted by mini-css-extract-plugin
export default {"scoreImage":"scoreImage__+TXBu","charBoxWrapper":"charBoxWrapper__diw6n","charBox":"charBox__J1dgb"};